var env = !!process && !!process.env && process.env.NODE_ENV;
var dev = env !== 'production' &&
    (!!process.env.development ||
        env === 'development' ||
        env === 'dev' ||
        env === 'test');
var ifConsole = !!dev && !!console;
var warn = ifConsole && !!console.warn ? console.warn : function () { return null; };
var error = ifConsole && !!console.error ? console.error : function () { return null; };
export var logger = {
    warn: warn,
    error: error,
};
//# sourceMappingURL=logger.js.map